var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "popup-form"
  }, [_c('div', {
    staticClass: "content-form-popup"
  }, [_c('div', {
    staticClass: "header-text"
  }, [_c('div', {
    staticClass: "back-button-wrapper pointer",
    on: {
      "click": _vm.closePopup
    }
  }, [_c('img', {
    staticClass: "nav-link-icon filter-primary",
    attrs: {
      "src": require("@/images/modal-close.svg"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "blackcolor pop-800"
  }, [_vm._v("Prerušenie schvaľovania")]), _c('button', {
    staticClass: "w-button saveformBtn",
    on: {
      "click": _vm.saveStatus
    }
  }, [_vm._v("Aktualizovať")])]), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label"
  }, [_vm._v("Dôvod prerušenia")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.dovod_prerusenia,
      expression: "formData.dovod_prerusenia"
    }],
    staticClass: "text-input w-input date-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.formData.dovod_prerusenia
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.formData, "dovod_prerusenia", $event.target.value);
      }
    }
  })])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }